import {
  ConnectionTypeEnum,
  RequestChannelEnum,
  RequestStatusEnum,
  ServiceTypeEnum,
} from "src/components/Premises/types";
import { HandoverTypeEnum } from "../types";

export function getFormBehavior(
  requestStatus: RequestStatusEnum,
  connectionType?: ConnectionTypeEnum,
  requestChannel?: RequestChannelEnum | null
) {
  if (!connectionType) {
    return { show: false, enable: false };
  }
  //filter out the connection type that is not allowed to be closed
  if (
    [
      ConnectionTypeEnum.TEMPORARY,
      ConnectionTypeEnum.SERVICE_CONNECTION,
    ].includes(connectionType)
  ) {
    return { show: false, enable: false };
  }
  const hiddenStatuses = [
    RequestStatusEnum.FINISHED,
    RequestStatusEnum.NONE,
    RequestStatusEnum.DISCARDED,
    RequestStatusEnum.CT_NOT_REQUIRED,
  ];

  const disabledStatuses = [
    RequestStatusEnum.DRAFT,
    RequestStatusEnum.DRAFT_ASSIGNED,
    RequestStatusEnum.SUBMITTED,
    RequestStatusEnum.CLOSED,
    RequestStatusEnum.STALLED,
    RequestStatusEnum.LODGED,
    RequestStatusEnum.CONNECTED,
    RequestStatusEnum.FAILED,
    RequestStatusEnum.IN_PROGRESS,
  ];

  const readOnlyStatuses = [
    RequestStatusEnum.CT_SUBMITTED,
    RequestStatusEnum.PROCESSED,
    RequestStatusEnum.CANCELLED,
    RequestStatusEnum.AWAITING_ACCOUNT_HOLDER,
  ];

  if (hiddenStatuses.includes(requestStatus)) {
    return { show: false, enable: false };
  } else if (disabledStatuses.includes(requestStatus)) {
    return { show: true, enable: false };
  } else if (
    requestStatus === RequestStatusEnum.COMPLETED &&
    RequestChannelEnum.NETWORK !== requestChannel
  ) {
    return { show: true, enable: true, showCTEntrance: true };
  } else if (readOnlyStatuses.includes(requestStatus)) {
    return { show: true, enable: false, readOnly: true };
  } else {
    // Default behavior for unknown statuses
    return { show: true, enable: true };
  }
}

export const handoverTypeToMsg = {
  [HandoverTypeEnum.CLOSE_AND_TRANSFER]: "Transfer accounts to the customer",
  [HandoverTypeEnum.CLOSE]: "Close accounts",
};

export const handoverTypeToLabelMap = {
  [HandoverTypeEnum.CLOSE_AND_TRANSFER]: "transfer",
  [HandoverTypeEnum.CLOSE]: "close",
};

export const handoverTypeToLabelMapPassive = {
  [HandoverTypeEnum.CLOSE_AND_TRANSFER]: "transferred",
  [HandoverTypeEnum.CLOSE]: "closed",
};

export const handoverTypeToStampMsg = {
  [HandoverTypeEnum.CLOSE_AND_TRANSFER]: "transfer",
  [HandoverTypeEnum.CLOSE]: "closure",
};

export const serviceTypeToStampMsg = {
  [ServiceTypeEnum.ELECTRICITY]: "electricity",
  [ServiceTypeEnum.GAS]: "gas",
};

export const serviceTypeToName = {
  [ServiceTypeEnum.ELECTRICITY]: "Electricity",
  [ServiceTypeEnum.GAS]: "Gas",
};

export const formatDateToString = (date: Date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const day = date.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};
